export default __webpack_public_path__ + "static/media/product27.3095e27f.png";